import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("orders/userdoc"),
  destroy:(id)=>clientAuth.delete(`orders/userdoc-destroy/${id}`),
  
};